export enum LinkedDocumentsVariant {
  Default = 'default',
  WithAccordion = 'with-accordion',
  LinkList = 'link-list',
}
